import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewCaledonia = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1683_3576)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H20V20H0V0Z",
				fill: "#009543"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H20V13.332H0V0Z",
				fill: "#ED4135"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 0H20V6.66797H0V0Z",
				fill: "#0035AD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.8125 16.5547C12.4326 16.5547 15.3672 13.6201 15.3672 10C15.3672 6.37995 12.4326 3.44531 8.8125 3.44531C5.19245 3.44531 2.25781 6.37995 2.25781 10C2.25781 13.6201 5.19245 16.5547 8.8125 16.5547Z",
				fill: "#FAE600",
				stroke: "black",
				strokeWidth: .7125
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.70312 10.9766H9.92578H7.70312ZM7.70312 9.33594H9.92578H7.70312ZM8.8125 3.46094V14.6641V3.46094Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.70312 10.9766H9.92578M7.70312 9.33594H9.92578M8.8125 3.46094V14.6641",
				stroke: "black",
				strokeWidth: .85
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.17187 16.0157C8.85156 17.1094 11.3594 16.086 11.3594 16.086C11.3594 16.086 10.4102 15.0625 9.92578 14.6602C9.45312 14.2696 8.05859 14.2852 7.58203 14.6602C7.1914 14.9727 6.05078 16.125 6.17578 16.0196L6.17187 16.0157Z",
				fill: "#000001"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.8125 14.0898C9.21808 14.0898 9.54687 13.6124 9.54687 13.0234C9.54687 12.4345 9.21808 11.957 8.8125 11.957C8.40692 11.957 8.07812 12.4345 8.07812 13.0234C8.07812 13.6124 8.40692 14.0898 8.8125 14.0898Z",
				fill: "#000001"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.8125 10.7187C9.30438 10.7187 9.70312 10.4669 9.70312 10.1562C9.70312 9.84559 9.30438 9.59375 8.8125 9.59375C8.32062 9.59375 7.92188 9.84559 7.92188 10.1562C7.92188 10.4669 8.32062 10.7187 8.8125 10.7187Z",
				fill: "#000001"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.8125 8.44531C9.30438 8.44531 9.70312 8.04657 9.70312 7.55469C9.70312 7.06281 9.30438 6.66406 8.8125 6.66406C8.32062 6.66406 7.92188 7.06281 7.92188 7.55469C7.92188 8.04657 8.32062 8.44531 8.8125 8.44531Z",
				fill: "#000001"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.88281 4.24609C9.88281 4.24609 9.96094 4.37109 9.79688 4.66406C9.01953 6.05859 8.24609 6.08984 8.09766 6.20703C7.93359 6.33984 7.86328 6.33203 7.86328 6.33203C7.87891 6.21484 7.88672 5.72266 7.89453 5.67578C8.01172 5.02734 9 5.03516 9.76953 4.36719C9.88672 4.26172 9.87891 4.24219 9.87891 4.24219L9.88281 4.24609ZM7.28125 7.24609C7.28125 7.24609 7.45703 7.74219 7.48047 8.24609C7.52344 9.04297 8.28906 9.06641 8.8125 9.06641V8.62109C8.42188 8.62109 8.07422 8.56641 7.79297 7.97656C7.64398 7.71864 7.47276 7.47423 7.28125 7.24609ZM7.25781 13.6914C7.25781 13.6914 7.53906 13.3398 7.86719 12.5352C7.94247 12.3438 8.07207 12.1786 8.24002 12.0599C8.40798 11.9412 8.60697 11.8742 8.8125 11.8672V11.2422C7.96875 11.2422 7.5625 11.5547 7.52344 12.0195C7.42969 12.957 7.25781 13.6875 7.25781 13.6875V13.6914ZM10.3516 7.24609C10.3516 7.24609 10.1719 7.74219 10.1484 8.24609C10.1055 9.04688 9.33984 9.06641 8.81641 9.06641V8.625C9.21094 8.625 9.55469 8.56641 9.83984 7.98047C9.98828 7.71875 10.1602 7.47266 10.3477 7.24609H10.3516ZM10.3711 13.6914C10.3711 13.6914 10.0937 13.3438 9.76172 12.5352C9.68583 12.3445 9.55598 12.1801 9.38807 12.0622C9.22016 11.9442 9.02149 11.8778 8.81641 11.8711V11.2461C9.66016 11.2461 10.0664 11.5586 10.1094 12.0195C10.1621 12.5817 10.2495 13.14 10.3711 13.6914Z",
				fill: "#000001"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1683_3576",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 10,
			fill: "white"
		})
	}) })]
});
export default SvgNewCaledonia;
